/** The public link page: one section, no login, nothing else on screen. */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ManualSteps from '../../components/manual/ManualSteps';

const base = typeof window !== 'undefined' ? window.location.origin : '';

const ManualPublic = () => {
    const { token } = useParams();
    const [row, setRow] = useState(null);
    const [gone, setGone] = useState(false);

    useEffect(() => {
        fetch(`${base}/api/manual/public/${token}`)
            .then((res) => (res.ok ? res.json() : Promise.reject(res)))
            .then((data) => setRow(data.section))
            .catch(() => setGone(true));
    }, [token]);

    if (gone) {
        return (
            <div className="min-h-screen bg-slate-950 text-white grid place-items-center px-6"
                 data-testid="manual-public-off">
                <p className="text-lg text-center">This link has been turned off.</p>
            </div>
        );
    }
    if (!row) return <div className="min-h-screen bg-slate-950" />;

    return (
        <div className="min-h-screen bg-slate-950 text-white" data-testid="manual-public-page">
            <div className="max-w-2xl mx-auto px-5 py-10">
                <ManualSteps section={row} />
                <p className="mt-12 text-xs text-slate-500">YulOnTap</p>
            </div>
        </div>
    );
};

export default ManualPublic;
